import React from 'react';
import { roles } from '@nxsys/store/constants';
import AgencyDetail from '../../../modules/agencies/detail';
import AgencyListing from '../../../modules/agencies/listing';
import CreateAgency from '../../../modules/agencies/create';
import EditGeneralInformation from '../../../modules/agencies/detail/EditGeneralInformation';
import EditPayrollFinance from '../../../modules/agencies/detail/EditPayrollFinance';

const ComingSoon = React.lazy(
  () => import('../../../modules/errorPages/ComingSoon'),
);

export const agencyConfig = [
  {
    permittedRole: roles.admin,
    path: '/agency',
    element: <AgencyListing />,
  },
  {
    permittedRole: roles.admin,
    path: '/agency/create',
    element: <CreateAgency />,
  },
  {
    permittedRole: roles.admin,
    path: '/agency/:agencyId',
    element: <AgencyDetail />,
  },
  {
    permittedRole: roles.admin,
    path: '/agency/:agencyId/:activeTab',
    element: <ComingSoon />,
  },
  {
    permittedRole: roles.admin,
    path: '/agency/:agencyId/generate-information/edit',
    element: <EditGeneralInformation />,
  },
  {
    permittedRole: roles.admin,
    path: '/agency/:agencyId/payroll-finance/edit',
    element: <EditPayrollFinance />,
  },
];
